import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { getApiUrl } from '../utils/api';
import './GitHubCallback.css';

const GitHubCallback = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const [status, setStatus] = useState('processing');
  const [error, setError] = useState('');

  useEffect(() => {
    const handleCallback = async () => {
      try {
        const token = searchParams.get('token');
        
        if (!token) {
          setError('Token não encontrado na URL');
          setStatus('error');
          return;
        }

        // Salvar token no localStorage
        localStorage.setItem('token', token);

        // Buscar dados do usuário
        const response = await fetch(getApiUrl('auth/me'), {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });

        if (response.ok) {
          const userData = await response.json();
          setUser(userData.user);
          setStatus('success');
          
          // Redirecionar para overview após 2 segundos
          setTimeout(() => {
            navigate('/overview');
          }, 2000);
        } else {
          throw new Error('Falha ao obter dados do usuário');
        }
      } catch (error) {
        console.error('Erro no callback GitHub:', error);
        setError(error.message);
        setStatus('error');
        
        // Redirecionar para login após 3 segundos em caso de erro
        setTimeout(() => {
          navigate('/login');
        }, 3000);
      }
    };

    handleCallback();
  }, [searchParams, navigate, setUser]);

  if (status === 'processing') {
    return (
      <div className="callback-container">
        <div className="callback-card">
          <div className="loading-spinner"></div>
          <h2>🔄 Processando login...</h2>
          <p>Aguarde enquanto finalizamos seu login com GitHub</p>
        </div>
      </div>
    );
  }

  if (status === 'success') {
    return (
      <div className="callback-container">
        <div className="callback-card success">
          <div className="success-icon">✅</div>
          <h2>Login realizado com sucesso!</h2>
          <p>Redirecionando para a visão geral...</p>
        </div>
      </div>
    );
  }

  if (status === 'error') {
    return (
      <div className="callback-container">
        <div className="callback-card error">
          <div className="error-icon">❌</div>
          <h2>Erro no login</h2>
          <p>{error}</p>
          <p>Redirecionando para a página de login...</p>
        </div>
      </div>
    );
  }

  return null;
};

export default GitHubCallback;